<template>
    <div class="mt-4">
        <b-row>
            <!-- Left column for status summary -->
            <b-col md="3" class="mt-2">
                <div v-for="(status, index) in statuses" :key="index"
                    @click="selectStatus(status)"
                    class="status-summary" :class="{ 'selected': selectedStatus.value === status.value }">
                    <b-card text-variant="black" class="mb-2">
                        <b-overlay :show="status.loading" no-wrap></b-overlay>
						<div class="status-summary-item d-flex justify-content-between">
                            <div>{{ status.name }}</div>
                            <small>
                                <strong>{{ status.totalRides }}</strong> Rides
                            </small>
						</div>
                    </b-card>
                </div>
            </b-col>

            <!-- Right column for displaying rides -->
			<b-col md="9" class="mt-2">
				<b-card v-if="selectedStatus">
					<b-overlay :show="selectedStatus.loading" no-wrap></b-overlay>
                    <div class="d-flex justify-content-between">
                        <h5 class="pt-4 text-uppercase" v-if="currentRides.length > 0">{{ selectedStatus.name }}</h5>
                        <b-pagination 
                            v-if="currentRides.length > 0"
                            :total-rows="selectedStatus.totalRides" 
                            v-model="pag.currentPage"
                            :per-page="pag.perPage" 
                            align="right"
                            class="mt-3"
                            @input="nextPage">
                        </b-pagination>
                    </div>

                    <div v-if="currentRides.length > 0" class="ride-list">
                        <!-- Card Service -->
						<b-card v-for="(ride, index) in selectedStatus.rides" :key="index" 
                            class="mb-3" 
                            :class="{ 'striped': index % 2 !== 0 }">
							<b-row>
								<b-col class="col-12 col-md-6">
                                    <p class="text-primary">
                                        <a href="#" @click.prevent="openReservation(ride)" class="text-primary font-weight-bold">{{ ride.serviceNumber }}</a>
                                        | <md-icon :icon="tripIcon(ride)"/>
                                        <span v-if="!$root.isEmpty(ride.internalReference)"> | {{ ride.internalReference }}</span>
                                    </p>
                                    <div class="text-muted small-text" v-if="!$root.isEmpty(ride.salesChannel)">
                                        {{ ride.salesChannel.name }}
                                    </div>
								</b-col>
								<b-col class="col-12 col-md-6">
                                    <p class="text-right text-primary">
										<b-badge :variant="getVariantBystatus(ride.status)" class="text-uppercase">{{ ride.status }}</b-badge>
                                    </p>
                                    <div class="text-right text-muted small-text" v-if="!$root.isEmpty(ride.supplier)">
                                        Operado por: {{ ride.supplier.name }}

                                        <strong v-if="ride.supplier.rate.total > 0"
                                            class="mr-1"
                                            v-b-tooltip.hover 
                                            :title=" ride.supplier.rate.total + ' Reviews'"
                                            > 
                                            {{ ride.supplier.rate.average }}
                                            <md-icon 
                                                icon="star"
                                                class="text-warning font-weight-bolder"
                                                style="font-size: 12px; padding-bottom: 2px;"
                                                />
                                        </strong>

                                        <b-badge :variant="iconSupplierConfirmation(ride.supplierConfirmation).class">
                                            <md-icon
                                                :icon="iconSupplierConfirmation(ride.supplierConfirmation).icon"
                                            />
                                        </b-badge>
                                    </div>
								</b-col>
							</b-row>

                            <!-- Tags -->
                            <div v-if="!$root.isEmpty(ride.tags)">
                                <b-badge variant="primary" class="mr-1" v-for="(tag,index) in ride.tags" :key="index">
                                    {{tag.text}}
                                </b-badge>
                            </div>

                            <!-- Driver and Vehicle Info -->
                            <b-row class="mt-2 align-items-center">
                                <b-col class="col-12 col-md-6">
                                    <div class="mb-0 d-flex justify-content-between">
                                        <p><b>Conductor: </b></p>
                                        <div>
                                           <p>{{ getDriverFromRide(ride) }}                                 
                                                <b-badge 
                                                    variant="primary" 
                                                    v-b-tooltip.hover title="Tarjeta de Identificación Aeroportuaria"
                                                    v-if="hasDriver(ride) && ride.driver.tia == true">
                                                    TIA
                                                </b-badge>
                                            </p>
                                        </div>
                                    </div>
                                </b-col>
                                <b-col class="col-12 col-md-6">
                                    <p class="mb-0 d-flex justify-content-between">
                                        <b class="text-sm">Unidad:</b> {{ getUnitFromRide(ride) }} 
                                    </p>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col class="col-12 col-md-6">
                                    <p class="d-flex justify-content-between">
                                        <b>Nombre cliente:</b> 
                                        <span>{{ ride.reservation.client.firstName }}  {{ ride.reservation.client.lastName }}</span>
                                    </p>
                                </b-col>
                                <b-col class="col-12 col-md-6">
                                    <p class="d-flex justify-content-between">
                                        <b>Número de vuelo:</b> 
                                        <span>
                                            <strong>{{ ride.flightNumber }} </strong>
                                            <md-icon icon="flight" class="text-secondary"></md-icon>
                                        </span>
                                    </p>
                                </b-col>
                            </b-row>

                            <!-- Fechas y horarios pickup y vuelo -->
                            <b-row>
                                <b-col class="col-12 col-md-6">
                                    <p class="d-flex justify-content-between">
                                        <b>Fecha y hora de pickup:</b> 
                                        <span>{{ ride.pickupDatetime }} Hrs.</span>
                                    </p>
                                </b-col>
                                <b-col class="col-12 col-md-6" v-if="ride.flightDatetime">
                                    <p class="d-flex justify-content-between">
                                        <b>Fecha y hora de vuelo:</b> 
                                        <span>{{ ride.flightDatetime}} Hrs.</span>
                                    </p>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col class="col-12 col-md-6">
                                    <p class="d-flex justify-content-between">
                                        <b>Origen:</b>
                                        <span>
                                            <a href="#" @click.prevent="showRouteMap(ride.geoData)">{{ ride.pickup.name }}</a> <md-icon class="text-danger" icon="place"/>
                                        </span>
                                    </p>
                                </b-col>
                                <b-col class="col-12 col-md-6">
                                    <p class="d-flex justify-content-between">
                                        <b>Destino:</b>
                                        <span>
                                            <a href="#" @click.prevent="showRouteMap(ride.geoData)">{{ ride.dropoff.name }}</a><md-icon class="text-danger" icon="place"/>
                                        </span>
                                    </p>
                                </b-col>

                                <b-col class="col-12 col-md-6">
                                    <p class="d-flex justify-content-between">
                                        <b>Tiempo de trayecto:</b>
                                        <span v-html="getTravelTime(ride) "></span>
                                    </p>
                                </b-col>

                                <b-col class="col-12 col-md-6">
                                    <p class="d-flex justify-content-between">
                                        <b>Distancia de trayecto:</b>
                                        <span>
                                            {{ getTravelLength(ride) }}
                                        </span>
                                    </p>
                                </b-col>
                            </b-row>

                            <section v-if="ride.trackingStatus=='pending'">
                                <b-row class="justify-content-center text-center">
                                    <b-col cols="6">
                                        <TrackingStatusService
                                            :itemService="ride"
                                            :justButton="true"
                                        />
                                        <span v-if="!$root.isEmpty(ride.canStartAt)" class="text-center">
                                            Inicio recomendado:
                                            <b>
                                                <RelativeTime :datetime="ride.canStartAt" :highlightFuturePast="true"></RelativeTime>
                                            </b>
                                        </span>
                                    </b-col>
                                </b-row>
                            </section>
                            <section  v-else-if="ride.trackingStatus=='done'" class="text-center">
                                <div v-if="logTracking= getLastUpdate(ride.logTrackingStatus) ">
                                    <div v-if="!$root.isEmpty(logTracking)">
                                        <small>
                                            Finalizado por: 
                                            <b>{{logTracking.userDriver.firstName}} {{ logTracking.userDriver.lastName }} </b> 
                                            <DateLabel :date="logTracking.created_at_utc "></DateLabel>
                                        </small>
                                    </div>
                                </div>
                            </section>
                            <section v-else>
                                <b-row class="text-right text-muted">
                                    <b-col>
                                        <div v-if="logTracking= getLastUpdate(ride.logTrackingStatus) ">
                                            <div v-if="!$root.isEmpty(logTracking)">
                                                <small>
                                                    <b>{{logTracking.userDriver.firstName}} {{ logTracking.userDriver.lastName }} </b> 
                                                    <RelativeTime :datetime="logTracking.created_at_utc"></RelativeTime>
                                                </small>
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row class="justify-content-center text-center">
                                    <b-col cols="6">
                                        <TrackingStatusService
                                            :itemService="ride"
                                            :justButton="true"
                                        />
                                        <span v-if="!$root.isEmpty(ride.canBeDoneUntil)" class="text-center">
                                            <small class="text-muted"> Limite para cerrar servicio </small>
                                            <b>
                                                <md-icon icon="hourglass_bottom"></md-icon>
                                                <RelativeTime :datetime="ride.canBeDoneUntil" :highlightFuturePast="true"></RelativeTime>
                                            </b>
                                        </span>
                                    </b-col>
                                </b-row>
                            </section>

                
                    

                            <!-- footer options -->
                            <template #footer>
                                <b-row>
                                    <b-col class="col-12 col-md-8">
                                        <div class="d-flex">
                                            <ReadyToBoard :ride="ride" lazy/>
                                            <RemainingTime
                                                :pickup-datetime="ride.pickupDatetime"
                                                :trip-type="ride.trip"
                                                :service-status="ride.status"
                                                :tracking-status="ride.trackingStatus"
                                                lazy/>     
                                        </div>
                                    </b-col>
                                    <b-col class="col-12 col-md-4 text-sm-right text-center">
                                        <b-button
                                            class="mr-1"
                                            size="sm"
                                            v-if="$hasPermission('realtime.tracking.changeStatus') && false"
                                            @click="showTrankingStatusService(ride)"
                                            v-b-tooltip.hover
                                            variant="outline-success"
                                            content="Tracking"
                                            v-tippy="{ arrow: true, arrowType: 'round' }"
                                        >
                                            <md-icon icon="emoji_transportation"></md-icon>
                                        </b-button>

                                        <b-button
                                            class="mr-1 chat-button"
                                            size="sm"
                                            v-if="$hasPermission('realtime.tracking.changeStatus')"
                                            @click="showDriverChat(ride)"
                                            v-b-tooltip.hover
                                            variant="outline-info"
                                            content="Chat conductor"
                                            v-tippy="{ arrow: true, arrowType: 'round' }"
                                        >
                                            <md-icon icon="chat"></md-icon>
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </template>
                            <!-- footer options -->
						</b-card>
                        <!-- End card service -->
					</div>
                    <div v-else>
						<p class="text-center">No se encontraron resultados</p>
					</div>
				</b-card>
				<b-card v-else>
					<p class="text-center">Seleccione una opción</p>
				</b-card>
			</b-col>
        </b-row>

        <!-- Modal detalle reserva de servicio -->
        <FormReservation
            ref="single"
            :formTypeWork="formTypeWork"
            :model-id="reservation.id"
            v-model="reservation.show"
        />

        <!-- Modal para actualizar tracking status del servicio -->
        <b-modal
            hide-footer
            ref="refTrackingStatus"
            size="md"
            :title="`Tracking del servicio`"
        >
            <TrackingStatusService
                :itemService="itemService"
                @closeModal=" () => { $refs['refTrackingStatus'].hide() }"
            />
        </b-modal>

        <b-modal
            size="xl"
            hide-footer
            ref="refDriverChat"
            title="Chat de conductor"
            @closeModal=" () => { $refs['refTrackingStatus'].hide() }">
            <DriverChat :transportServiceId="transportServiceId"/>
        </b-modal>

        <b-modal
            size="xl"
            hide-footer
            ref="refMap"
            title="Mapa de trayecto"
            @closeModal=" () => { $refs['refMap'].hide() }">
            <LeafletMap :geo-details="geoData" :zoom="11" :rounting="true"/>
        </b-modal>
    </div>    
</template>

<script>
import FormReservation from "../../reservation/formReservation/index.vue";
import TrackingStatusService from "./TrackingStatusService.vue";
import DriverChat from "../../reservations/tracking/DriverChat.vue";
import LeafletMap from "../../../helpers/LeafletMap.vue";
import RemainingTime from "./RemainingTime.vue";
import ReadyToBoard from "./ReadyToBoard.vue";
import RelativeTime from "./RelativeTime.vue";
import DateLabel from "../../../helpers/DateLabel.vue";
export default {
    props:{
		filters:{
			type : Object,
			required: true
		}
	},
	components:{ FormReservation, TrackingStatusService, DriverChat, LeafletMap, RemainingTime, ReadyToBoard, RelativeTime,DateLabel },
    data() {
        return {
            loading:false,
			reservation:{
				id: -1,
				show: false
			},
            statuses: [
				{value:'pending',        name: 'Por Iniciar', rides:[], color: 'outline-primary', loading: false, totalRides:0},
                {value:'onWayToPickup',  name:'Rumbo a pickup',rides:[],color: 'primary',loading:false,totalRides:0},
				{value:'atPickup',       name: 'En lugar de pickup',rides:[],color: 'primary',loading:false,totalRides:0},
				{value:'onWayToDropoff', name:'Rumbo a dropoff',rides:[],color: 'primary',loading:false,totalRides:0},
				{value:'finished',       name: 'Completado',rides:[],color: 'primary',loading:false,totalRides:0},
				{value:'noShow',         name:'Completado (No show)',rides:[],color: 'primary',loading:false,totalRides:0},
			],
            selectedStatus: { value:"", rides:[] },
            rides: [],
            pag: {
                currentPage: 1,
                perPage: 10
            },
            formTypeWork: "viewForm",
            itemService: null,
            transportServiceId: -1,
            geoData: null,
            interval: null,
            time: new Date()
        }
    },
    async created() {
		this.loading = true;
       
		for (let i = this.statuses.length - 1; i >= 0; i--) {
			try {
				await this.selectStatus(this.statuses[i]);
			} catch (error) {
				console.error('Error processing status:', error);
			}
		}
		this.loading = false;
	},
    beforeDestroy() {
        clearInterval(this.interval);
    },
    computed: {
        currentRides() {
            if (this.$root.isEmpty(this.selectedStatus.rides)) return [];
            return this.selectedStatus.rides;
        },
        offset(){
            let offset = this.pag.perPage * (this.pag.currentPage - 1 );
            return offset;
        }
    },
    methods: {
        async getRides(status) {
			try {
                let _filters = {...this.filters,...{trackingStatus:status}}
                let params = {
                    filters:_filters,
                    limit:this.pag.perPage,
                    offset:this.offset,
                    sortBy:"pickupDatetime",
                    sortOrder:'ASC'
                }
                const response = await this.$root.api
                .get(`/live-operation/transport-services`,{params:params})
                return response.data;
            } catch(error) {
                this.$root.showAlert("Error fetching rides with status: "+status,{variant:'danger'});
                return [];
            }
		},
        async selectStatus(status, isPagination = false) {
            
            if (!isPagination) {
                this.pag.currentPage=1
            }

            this.selectedStatus = status;
            status.loading      = true;

            let ridesResponse = await this.getRides(status.value);
            status.rides      = ridesResponse.rows;
            status.totalRides = ridesResponse.totalRows??0;
            status.loading    = false;
		},
        async refresh() {
            this.loading = true;
            for (let i = this.statuses.length - 1; i >= 0; i--) {
                try {
                    await this.selectStatus(this.statuses[i]);
                } catch (error) {
                    console.error('Error processing status:', error);
                }
            }
            this.loading = false;
        },
        async updateTotalsByStatus(){
            for (let i = this.statuses.length - 1; i >= 0; i--) {
                try {
                    let ridesResponse = await this.getRides(this.statuses[i].value);
                    this.statuses[i].rides      = ridesResponse.rows
                    this.statuses[i].totalRides = ridesResponse.totalRows??0;
                } catch (error) {
                    console.error('Error processing status:', error);
                }
            }
        },
        refreshCurrentList() {
            this.selectStatus(this.selectedStatus,true)
        },
        nextPage(newPage) {
            this.pag.currentPage = newPage;
            this.selectStatus(this.selectedStatus,true)
        },
        tripIcon(rideModel) {
			if (rideModel.pickup.isAirport) return "flight_land";
			//A2H
			else if (rideModel.dropoff.isAirport) return "flight_takeoff";
			//H2A
			else return "place"; //P2P
		},
        openReservation(rideModel) {
			this.reservation.id   = rideModel.reservationId,
			this.reservation.show = true;
		},
        getVariantBystatus(status){
			try{
				let variant = this.$root.auxVars.transportServiceStatusOpts.find((el)=>{
					return el.value==status
				});
				if(variant) return variant.class;
			}catch(err){console.log(err)}
			return "info";
		},
        getDriverFromRide(ride){
            if(this.$root.isEmpty(ride.driver)) return '--';
            return ride.driver.firstName+" "+ride.driver.lastName//+" "+ride.reviewDriver.average
        },
        getUnitFromRide(ride){
            if(this.$root.isEmpty(ride.transportUnit)) return '--';
            return ride.transportUnit.title;
        },  
        hasDriver(ride) {
            if (!this.$root.isEmpty(ride.driver)) return true
            return false;
        },
        showTrankingStatusService(item) {
            this.itemService = item;
            this.$refs["refTrackingStatus"].show();
        },
        showRouteMap(geoData) {
            if (geoData) {
                this.geoData = [geoData]
                this.$refs["refMap"].show();
            }
        },
        showDriverChat(ride) {
            this.transportServiceId = ride.id;
            this.$refs["refDriverChat"].show();
        },
        
        getTravelTime(ride) {
            if (!this.$root.isEmpty(ride.travelTime) && !this.$root.isEmpty(ride.travelTimeWithTraffic)) {
                if(ride.travelTime != ride.travelTimeWithTraffic ){
                    return `<small style="text-decoration: line-through; opacity: 0.6;">${Math.trunc(ride.travelTime)} min.</small> ${Math.trunc(ride.travelTimeWithTraffic)} min.`;
                }
            }
            if (!this.$root.isEmpty(ride.travelTime)) {
                return `${Math.trunc(ride.travelTime)} min. aprox.`;
            }
            return '';
        },
        getTravelLength(ride) {
            let string = ''
            if (!this.$root.isEmpty(ride.travelLength)) {
                string += `${ride.travelLength} km. (maps)`
            }

            if (this.$root.isEmpty(ride.travelLength) && !this.$root.isEmpty(ride.distanceCalculation)) {
                string += `${ride.distanceCalculation} km. aprox.`
            }

            return string
        },
        iconSupplierConfirmation(status) {
            let icon = "";
            let classe = "";
            switch (status) {
                case "pending":
                    icon = "warning";
                    classe = "warning";
                    break;
                case "confirmed":
                    icon = "check_circle";
                    classe = "success";
                    break;
                case "rejected":
                    icon = "dangerous";
                    classe = "danger";
                    break;
            }
            return { icon: icon, class: classe };
        },
        getLastUpdate(logs){
            if(this.$root.isEmpty(logs)){
                return null;
            }
            return logs.find(x => x.trackingStatus === this.selectedStatus.value)
        }
    },
}
</script>

<style scoped>
    .status-summary {
        cursor: pointer;
    }
    .status-summary.selected .card {
        background-color: #007bff;
        color: white;
    }

    .status-summary-item.selected {
        background-color: rgba(0, 0, 0, 0.1) !important;
    }

    .status-color {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 10px;
    }

    p{
        margin: 0.5px;
        font-size: 14px;
    }
    .striped{
        background-color: #f4f8fc;
    }

    .card-footer {
        background-color: white !important;
        padding: 5px 10px;
    }

    .small-text {
        font-size: 12px
    }
</style>